import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription } from '@/Domain/components/Shared/Alert/Alert';
import { Button } from '@/Domain/components/Shared/Button/Button';

interface ArticleSheetErrorProps {
  isRetrying: boolean;
  onRetry: () => void;
}

export const ArticleSheetError = ({ isRetrying, onRetry }: ArticleSheetErrorProps) => {
  const { t } = useTranslation(['knowledge_base']);

  return (
    <div className="flex h-full items-center justify-center py-8" data-testid="article-sheet-error">
      <Alert variant="destructive" className="max-w-md">
        <AlertCircle className="size-4 !text-destructive" />
        <AlertDescription className="space-y-3">
          <p className="m-0">{t('knowledge_base:article.load_error')}</p>
          <Button
            type="button"
            variant="secondary"
            size="sm"
            loading={isRetrying}
            onClick={onRetry}
            data-testid="article-sheet-retry"
          >
            {t('knowledge_base:article.retry')}
          </Button>
        </AlertDescription>
      </Alert>
    </div>
  );
};
